<template>
  <card>
    <list
      v-if="$store.state.user.sections['tariffs']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :isUpdate="true"
      :isAdd="true"
      :itemLink="itemLink"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="true"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      params: {},
      val: [],
      modalCreate: "dealer",
      fields: [
        {
          key: "price_from",
          col: "col-6",
          label: "Цена от",
          labelKey: "price_from",
          type: "field",
          textType: "number",
        },
        {
          key: "price_till",
          col: "col-6",
          label: "Цена до",
          labelKey: "price_till",
          type: "field",
          textType: "number",
        },
        {
          key: "name",
          col: "col-12",
          label: "Название",
          labelKey: "name",
          isMultiLang: true,
          type: "field",
        },
        {
          key: "description",
          col: "col-12",
          label: "Описание",
          labelKey: "description",
          isMultiLang: true,
          type: "textarea",
        },
        {
          label: "Выберите услугу",
          key: "service",
          labelKey: "select_service",
          type: "select",
          modal: "service",
          selectKey: "name",
        },
      ],
      /** APIs */
      removeLink: "",
      cardLink: "item_tariff",
      itemLink: "tariffs",
      setLink: "tariffs",
      columns: [
        {
          key: "name",
          title: "Название",
        },
        {
          key: "service",
          object: "name",
          title: "Сервис",
          titleKey: "service",
        },
        {
          detail: true,
          // remove: true,
        },
      ],
    };
  },
};
</script>
<style>
</style>
